const pages = {
  access_levels: {
    create: 'Crear un nivel de acceso',
    edit: 'Editar un nivel de acceso',
  },
  controllers: {
    activate: 'Activar un controlador',
    edit: 'Editar un controlador',
  },
  credentials: {
    create: 'Crear una credencial',
    edit: 'Editar una credencial',
  },
  doors: {
    edit: 'Editar una puerta',
  },
  holidays: {
    create: 'Crear vacaciones',
    edit: 'Editar vacaciones',
  },
  inputs: {
    edit: 'Editar una entrada',
  },
  interlocks: {
    create: 'Crear un interbloqueo',
    edit: 'Editar un interbloqueo',
  },
  outputs: {
    edit: 'Editar una salida',
  },
  schedules: {
    create: 'Crear un calendario',
    edit: 'Editar un calendario',
  },
  sites: {
    create: 'Crear un sitio',
  },
  users: {
    create: 'Crear un usuario',
    edit: 'Editar un usuario',
  },
};

export default pages;
